export const apiConfig = {
    apiGateway: {
        URL: "https://343zstlxma.execute-api.eu-central-1.amazonaws.com/dev"
    }
};